export default __webpack_public_path__ + "static/media/about_show_1.f58f96a6.png";